import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { ProjetAgenceModel, ProjetSchemaDescrModel } from 'src/app/shared/models/simple-types/projet-models.model';
import { ToastrService } from 'ngx-toastr';
import { ProjetAgenceService } from 'src/app/shared/services/simple/projet-agence.service';
import { ProjetSchemaService } from 'src/app/shared/services/simple/projet-schema.service';
import { ProjetAgenceDemandeService } from 'src/app/shared/services/simple/projet-agence-demande.service';

export interface DialogData {
  icone: string;
  type: string;
  title: string;
  subTitle: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  footer: string;
  projetSchemaDescr: ProjetSchemaDescrModel;
  model: any;
  projetAgence: ProjetAgenceModel;
}

@Component({
  selector: 'app-modal-modif-formly',
  templateUrl: './modal-modif-formly.component.html'
})
export class ModalModifFormlyComponent implements OnInit {
  icone: string;
  title: string = "Titre";
  subTitle: string = "Sous-titre";
  message: string = "Message";
  color: string = "success";
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  type: string;
  footer: string = null;
  disabled: boolean = false;
  schema: FormlyFieldConfig[];
  form: FormGroup<any> = new FormGroup({});

  oldProj: ProjetAgenceModel;


  constructor(public dialog: MatDialog,
              public router: Router,
              public dialogRef: MatDialogRef<Component>,
              private toastrService: ToastrService,
              private projetAgenceService: ProjetAgenceService,
              private projetSchemaService: ProjetSchemaService,
              private projetAgenceDemandeService: ProjetAgenceDemandeService,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {

    this.oldProj = Object.assign([], this.data.projetAgence);

    this.initSchema();
    this.applyDisabled();
    this.icone = this.data.icone !== undefined ? this.data.icone : '';
    this.title = this.data.title !== undefined ? this.data.title : '';
    this.subTitle = this.data.subTitle !== undefined ? this.data.subTitle : '';
    this.icon_color = this.data.icon_color !== undefined ? this.data.icon_color : '';
    this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
    this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
    this.message = this.data.message;
    this.color = this.data.color;
    this.type = this.data.type;
    this.footer = this.data.footer;
  }

  initSchema() {
    if (this.data.projetSchemaDescr?.schema) {
      this.schema = JSON.parse(this.data.projetSchemaDescr.schema);
    }
  }

  applyDisabled()
  {
    if (this.data.projetSchemaDescr?.schema && this.disabled != null && this.disabled != undefined) {
      this.schema.map((field: FormlyFieldConfig) => {
        this.applyDisableOnElem(field);
      });
      this.data.projetSchemaDescr.schema = JSON.stringify(this.schema);
    }
  }

  applyDisableOnElem(elemFieldConfig) {
    if (elemFieldConfig?.props)
      elemFieldConfig.props.disabled = this.disabled;
    if (elemFieldConfig?.fieldGroup) {
      elemFieldConfig?.fieldGroup.map((subfield: FormlyFieldConfig) => {
        this.applyDisableOnElem(subfield);
      });
    }
  }

  onModalCancel(): void {
    this.dialogRef.close(null);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      this.data.projetAgence.idProjetSchemaDescr = this.data.projetSchemaDescr.id;
      this.data.projetAgence.projetSchemaDescr = this.data.projetSchemaDescr;
      this.projetSchemaService.get(this.data.projetAgence.projetSchemaDescr.id).subscribe((descr) => {
        let modifs = this.projetAgenceDemandeService.generateModif(descr, this.oldProj, this.data.projetAgence);
        this.projetAgenceService.createOrSave(this.data.projetAgence, modifs).subscribe(res => {
          this.toastrService.success("Formulaire agence enregistré");
          this.dialogRef.close(
            {
              model: this.data.model,
              projetAgence: res,
              form: this.form
            });
        }, (error) => {
          this.toastrService.error("Erreur dans l’enregistrement.");
        });
      });
    } else {
      this.displayErrors();
      this.toastrService.warning("Formulaire invalide");
    }
  }

  displayErrors() {
    for (const ctrl in this.form.controls) {
      if (ctrl) {
        this.form.controls[ctrl].markAsTouched();
      }
    }
  }

  modelChanges(model) {
    this.data.projetAgence.projet = JSON.stringify(model);
    this.data.model = model;
  }
}
